import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

const PostDetails = () => {
    const postImages = [
        { img: '/images/news/1/NewsOspemifene.png' },
    ];

    return (
        <div className="st-content">
            {/* Page heading */}
            <div
                className="st-page-heading st-dynamic-bg"
                style={{ backgroundImage: `url('/images/news/1/NewsOspemifene.png')` }}
            >
                <div className="container">
                    <div className="st-page-heading-in text-center">
                        <h4>
                            <Link to="/" className="st-back-to-home">
                                <Icon icon="ph:arrow-left-bold" /> Torna alla Home
                            </Link>
                        </h4>
                        <h1 className="st-page-heading-title">
                            Ospemifene nel trattamento dell’Atrofia <br></br>Vulvo-Vaginale
                        </h1>
                        <div className="st-post-label">
                            <span>22 Luglio 2025</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="st-height-b100 st-height-lg-b80" />

            <div className="container">
                <div className="row">
                    {/* Main content */}
                    <div className="col-lg-8">
                        <div className="st-post-details st-style1">

                            {/* Hero image */}
                            <img
                                className="st-zoom-in"
                                src="/images/news/1/NewsOspemifene.png"
                                alt="Ospemifene"
                            />

                            {/* Article sections */}
                            <h2 id="cos-e-avv">Cos’è l’atrofia vulvo-vaginale (AVV)?</h2>
                            <p>
                                L’atrofia vulvo-vaginale (AVV) è una condizione cronica e progressiva legata
                                alla ridotta estrogenizzazione dei tessuti genitali femminili, tipicamente
                                associata alla sindrome genitourinaria della menopausa. Non si risolve
                                spontaneamente nella maggior parte dei casi e può influire significativamente
                                sulla qualità della vita della donna.
                            </p>

                            <h2 id="tessuti-vaginali">Cambiamenti nei tessuti vaginali in post-menopausa</h2>
                            <ul>
                                <li>Epitelio più sottile e meno elastico</li>
                                <li>Pieghe vaginali appiattite</li>
                                <li>pH ≥ 4,6, con riduzione delle difese naturali</li>
                                <li>Diminuzione di flusso sanguigno e lubrificazione</li>
                                <li>↓ cellule superficiali &lt; 5%, ↑ cellule parabasali</li>
                            </ul>

                            <img
                                className="st-zoom-in"
                                src="/images/news/1/Ospemifene2.png"
                                alt="Ospemifene"
                            />

                            <h2 id="diagnosi-impatto">Diagnosi e impatto sulla qualità di vita</h2>
                            <p>
                                La diagnosi si basa su esame clinico e sintomi riferiti (secchezza, bruciore,
                                dispareunia). Studi REVIVE ed EVES mostrano impatti negativi su:
                            </p>
                            <ul>
                                <li>Piacere sessuale (75%)</li>
                                <li>Relazione di coppia e intimità</li>
                                <li>Spontaneità sessuale</li>
                                <li>Desiderio sessuale ridotto di un terzo</li>
                            </ul>

                            <h2 id="profilo-ospemifene">Profilo di Ospemifene</h2>
                            <p>
                                Ospemifene 60 mg è il primo SERM orale specifico per AVV moderata-severa in
                                post-menopausa. Non contiene ormoni e agisce tessuto-specificamente:
                            </p>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Tessuto</th>
                                        <th>Effetto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr><td>Vaginale</td><td>Agonista</td></tr>
                                    <tr><td>Osso</td><td>Agonista</td></tr>
                                    <tr><td>Cervello</td><td>Agonista</td></tr>
                                    <tr><td>Mammella</td><td>Antagonista</td></tr>
                                    <tr><td>Endometrio</td><td>Neutro</td></tr>
                                    <tr><td>Cuore</td><td>Neutro</td></tr>
                                </tbody>
                            </table>

                            <img
                                className="st-zoom-in"
                                src="/images/news/1/Ospemifene3.png"
                                alt="Ospemifene"
                            />

                            <h2 id="efficacia-clinica">Evidenze cliniche</h2>
                            <p>
                                Ospemifene favorisce la rigenerazione dell’epitelio vaginale:
                            </p>
                            <ul>
                                <li><strong>12 settimane:</strong> ↑ cellule superficiali, ↓ parabasali, pH ridotto</li>
                                <li><strong>1 anno:</strong> miglioramenti fisiologici mantenuti</li>
                            </ul>

                            <h2 id="profilo-sicurezza">Profilo di sicurezza</h2>
                            <p>
                                RCT non hanno evidenziato differenze significative vs placebo in:
                            </p>
                            <ul>
                                <li>Esami mammari (palpazione, mammografia)</li>
                                <li>Spessore e istologia endometriale</li>
                                <li>Rischi tromboembolici o cardiovascolari</li>
                                <li>Sanguinamenti vaginali</li>
                            </ul>

                            <h2 id="conclusioni">Conclusioni</h2>
                            <p>
                                Ospemifene rappresenta un’opzione innovativa, orale e non-ormonale per le
                                donne con AVV sintomatica. Grazie a efficacia e sicurezza validate, migliora il
                                benessere intimo e la qualità della vita in menopausa.
                            </p>

                            {/* Image slider */}
                            <div className="st-height-b35 st-height-lg-b35" />
                            <img
                                className="st-zoom-in"
                                src="/images/news/1/Ospemifene4.png"
                                alt="Ospemifene"
                            />

                        </div>
                    </div>

                    {/* Sidebar with index */}
                    <div className="col-lg-4">
                        <div className="st-widget st-sidebar-widget st-sidebar-sticky" >
                            <h3 className="st-widget-title">Indice</h3>
                            <ul className="st-widget-list">
                                <li><ScrollLink to="cos-e-avv" spy={true} duration={500}>Cos’è l’AVV?</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500}  to="tessuti-vaginali">Cambiamenti tessuti</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500} to="diagnosi-impatto">Diagnosi & Impatto</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500} to="profilo-ospemifene">Profilo Ospemifene</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500} to="efficacia-clinica">Evidenze cliniche</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500} to="profilo-sicurezza">Profilo sicurezza</ScrollLink></li>
                                <li><ScrollLink spy={true} duration={500} to="conclusioni">Conclusioni</ScrollLink></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="st-height-b100 st-height-lg-b80" />
        </div>
    );
};

export default PostDetails;
